import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Draggable from 'react-draggable';
import { Timeout } from './utils/Common';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export class LoginForcedPasswordChangeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new_password: '',
      confirm_password: '',
      newPasswordVisible: false,
      confirmPasswordVisible: false,
      alert: props.alert || {
        color: 'info',
        message: '',
        isOpen: false,
      },
      deltaPosition: { x: 0, y: 0 },
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.setNewPasswordVisible = this.setNewPasswordVisible.bind(this);
    this.setConfirmPasswordVisible = this.setConfirmPasswordVisible.bind(this);

    // Create ref for the new password input
    this.newPasswordRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts
    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the new password field
    setTimeout(() => {
      if (this.newPasswordRef.current) {
        this.newPasswordRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  componentWillUnmount() {
    this.setState({ isMounted: false }); // Set isMounted to false when the component unmounts
    document.removeEventListener('keydown', this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  async keydownHandler(e) {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
    if (e.keyCode === 27) {
      this.handleCancel();
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = () => {
    const { new_password, confirm_password } = this.state;
    if (new_password !== confirm_password) {
      alert('Passwords do not match');
      return;
    }
    this.props.handleNewPasswordChallenge(this.props.state.email, new_password);
  };

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  handleCancel = () => {
    this.props.handleResetModel();
    this.props.setForcePasswordChangeModal(false);
  };

  setNewPasswordVisible(show) {
    this.setState({ newPasswordVisible: show });
  }

  setConfirmPasswordVisible(show) {
    this.setState({ confirmPasswordVisible: show });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable
        handle=".login-force-password-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <Modal
          isOpen={this.props.forcePasswordChangeModal}
          toggle={this.props.setResetPasswordModal}
          style={{
            transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
            width: '500px',
            height: '300px',
          }}
          backdrop="static"
        >
          <ModalHeader className="login-force-password-handle handle">
            Reset Password
          </ModalHeader>
          <ModalBody>
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <Alert
                color={this.props.alert.color}
                isOpen={this.props.alert.isOpen}
              >
                {this.props.alert.message}
              </Alert>
            </Col>
          </Row>

          <p>Password Reset Required</p>

          <div className="form-group">
            <label htmlFor="new_password">New Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={this.state.newPasswordVisible ? 'text' : 'password'}
                name="new_password"
                className="form-control"
                id="new_password"
                ref={this.newPasswordRef}
                value={this.state.new_password}
                onChange={this.handleChange}
                placeholder="Enter your new password"
                autoComplete="off"
                style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
              />
              <span
                className="password-toggle-icon"
                onClick={() =>
                  this.setNewPasswordVisible(!this.state.newPasswordVisible)
                }
                style={{
                  position: 'absolute',
                  right: '0.5rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }}
              >
                {this.state.newPasswordVisible ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirm_password">Confirm Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={this.state.confirmPasswordVisible ? 'text' : 'password'}
                name="confirm_password"
                className="form-control"
                id="confirm_password"
                value={this.state.confirm_password}
                onChange={this.handleChange}
                placeholder="Confirm your new password"
                autoComplete="off"
                style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
              />
              <span
                className="password-toggle-icon"
                onClick={() =>
                  this.setConfirmPasswordVisible(
                    !this.state.confirmPasswordVisible
                  )
                }
                style={{
                  position: 'absolute',
                  right: '0.5rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }}
              >
                {this.state.confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
          </ModalBody>
          <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.handleSubmit}
          >
            Submit
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={this.handleCancel}
          >
            Cancel
          </button>
          </ModalFooter>
        </Modal>
      </Draggable>
    );
  }
}
